import { useState, useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  ProductSupplier,
} from "../../../../app/slices/productsSupplierSlice";
import { Controller, useForm } from "react-hook-form";
import { HiOutlineTruck, HiOutlineIdentification } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const ProductSupplierForm = () => {
  const _ProductSupplier = useSelector((state) => state.productSupplier.productSupplier);
  const _SearchBody = useSelector((state) => state.productSupplier.searchBody);

  const isAdd = _ProductSupplier.form.id ? false : true;
  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: _ProductSupplier.form,
  });


  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(ProductSupplier.create(data));
    } else {
      dispatch(ProductSupplier.update(data.id, data, _SearchBody));
    }
  };
  useEffect(() => {
    reset({ ..._ProductSupplier.form });
  }, [_ProductSupplier.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_ProductSupplier.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineTruck />}
      title={isAdd ? "إضافة مجهز جديد" : "تعديل المجهز"}
      subtitle={
        isAdd
          ? "أدخل معلومات المجهز لإضافته"
          : "قم بتحديث معلومات المجهز ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineIdentification />} title="معلومات المجهز">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ProductSupplierForm;
